import styled from 'styled-components';
import { gridSizes } from 'utils/style';
import ModalSummary from './ModalSummary';

export default styled(ModalSummary)`
  margin: 0;
  padding: ${gridSizes('S')} ${gridSizes('L')} ${gridSizes('L')};
  border-bottom: solid 1px var(--grey300);
  list-style-type: none;

  .driver-info {
    margin: 0;
    color: var(--grey700);

    &__driver-label,
    &__driver-name {
      color: var(--grey900);
      font-weight: 500;
    }
  }
`;
